<template>
  <div class="single-content-search-result">
    <div class="result-article-id d-none">{{item.articleId}}</div>
    <a
      class="result-header"
      href="#"
      @click.prevent="loadNewContent(item)"
    >
      <span class="result-location-data">{{formattedLocationData(item.locationData)}} </span>

      <text-highlight
        highlightClass="tuka-text-highlight" 
        :queries="queries"
      >{{item.header}}</text-highlight>
    </a>


    <div 
      class="search-result in-content"
      v-if="item.content.length"
    >
      <div class="results-count d-none">{{$t('tuka.search.text_results_in_content')}} {{item.content.length}}</div>
      <!-- Display only the first result by default -->
      <div v-for="(result, index) of item.content" :key="formattedLocationData(item.locationData) + '-content-' + index" class="sub-result">
        <div v-show="index == 0">
          <div class="result-text">
            <text-highlight 
              highlightClass="tuka-text-highlight" 
              :queries="queries"
            >{{result.resultText}}</text-highlight>  
          </div>
          <div class="result-term d-none">{{result.searchTerm}}</div>
        </div>
      </div>
    </div>

    <div 
      class="search-result in-header"
      v-else-if="item.title.length"
    >
      <div class="results-count d-none">{{$t('tuka.search.text_results_in_header')}} {{item.title.length}}</div>
      <!-- Display only the first result by default -->
      <div v-for="(result, index) of item.title" :key="formattedLocationData(item.locationData) + '-header-' + index" class="sub-result">
        <div v-show="index == 0">
          <div class="result-text">
            {{$t('tuka.search.header')}} 
            <text-highlight 
              highlightClass="tuka-text-highlight" 
              :queries="queries"
            >{{result.resultText}}</text-highlight>  
          </div>
          <div class="result-term d-none">{{result.searchTerm}}</div>
        </div>
      </div>
    </div>


    <div 
      class="search-result in-categories"
      v-else-if="item.categories.length"
    >
      <div class="results-count d-none">{{$t('tuka.search.text_results_in_categories')}} {{item.categories.length}}</div>
      <!-- Display only the first result by default -->
      <div v-for="(result, index) of item.categories" :key="formattedLocationData(item.locationData) + '-categories-' + index" class="sub-result">
        <div v-show="index == 0">
          <div class="result-text">
            {{$t('tuka.search.theme_word')}} 
            <text-highlight
              highlightClass="tuka-text-highlight" 
              :queries="queries"
            >{{result}}</text-highlight>  
          </div>
        </div>
      </div>
    </div>

    <div class="results-count-single">
      {{$t('tuka.search.text_results_count_in_single_article')}} 
      <span class="results-count-single-amount">{{item.title.length + item.content.length + item.categories.length}}</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TextHighlight from 'vue-text-highlight';
import { createUrlString, formattedLocationData } from "../store/helpers";

import SearchInfo from "./SearchInfo.vue";

export default {
  name: "SearchResults",
  components: {  
    SearchInfo,
    TextHighlight
  },
  props: {
    item: Object,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["searchResults", "themeWords", "getSettings", "getTextSearchStaticValue"]),
    queries() {
      // Also use search word version without " characters in highlighting items 
      let queryArray = [];
      queryArray.push(this.getTextSearchStaticValue);
      queryArray.push(this.getTextSearchStaticValue.replace(/"/g, ""));
      return queryArray;
    }
  },
  methods: {
    ...mapActions(["setSearchResults", "setSettings", "setScrollingReserved", "setTextSearchValue", "setVisibleContentId"]),
    formattedLocationData: formattedLocationData,
    clearNavigationWidth() {

      // Set content into normal width, show full-size sidebar
      let tempSettings = this.getSettings;
      tempSettings.showContentWindowInFullWidth = false;
      this.setSettings(tempSettings);

      // Focus search field for faster re-inputs
      this.$nextTick(() => {
        document.getElementById('word-search').focus({
          preventScroll: true
        });
      });
    },
    loadNewContent(item) {

      // Display sidebar when moving from search results to target item
      let tempSettings = this.getSettings;
      tempSettings.showContentWindowInFullWidth = false;
      this.setSettings(tempSettings);

      /* 1. Get target location info and set it into params */
      let tempLocation = [];
      if (item.locationData) { // Normal item, use locationData
        for (let i = 1; i < item.locationData.length; i++) {
          tempLocation.push(item.locationData[i]);
        }
      } else if (this.singleInfoItemIndex !== 'undefined') { // infoItem, use name
        let urlName = createUrlString(item.header);
        tempLocation.push(urlName)
      }

      /* 1.1 If result target is same as accordion level set URL to load all child items into view */
      if (parseInt(this.getSettings.accordionActivationLevel) == tempLocation.length) {
        // Also check if item has child items to show, prompting e.g. .../2 --> .../2/0
        if (item.childItems) {
          tempLocation.push(0);
        }
      }
      
      let pushParams = {
        componentPage: this.$router.currentRoute.params.componentPage,
        componentId: tempLocation,
      }

      /* 2. Get possibly active filters and set them into query */
      // let activeThemewords = Object.keys(this.themeWords).filter(key => this.themeWords[key] === true);
      // let pushQuery = {
      //   themeword: activeThemewords
      // };
      let pushQuery = {}; // Always reset themeword-parameter

      /* 3. Dispatch router request with parameters, e.g. /katsaus/2/0?themeword=ilmastonmuutos#22 */
      this.$router.push({
        name: 'componentpage',
        params: pushParams,
        query: pushQuery,
        hash: this.$router.currentRoute.hash
      }).catch(err => { console.log("Reroute to same location, avoiding")})
      
      this.setSearchResults({ errorMessage:"", data:[] });

      // Scroll into top of main content
      this.$nextTick(() => {

        // Set visible content id (creates indicator) when item is clicked
        this.setVisibleContentId(this.item.articleId);
        
        this.setScrollingReserved(true);

        // If menu toggle is visible (mobile mode) close the menu
        if (jQuery('.settings-box.visual-settings:visible').length) {
          let tempSettings = {...this.getSettings};
          tempSettings.showContentWindowInFullWidth = true; // closes mobile menu 
          this.setSettings(tempSettings);
        }
        
        setTimeout(() => {
          let scrollTarget = jQuery('.tukave-main-content');
          scrollTarget[0].scrollIntoView({behavior: "smooth"});

        }, 100);

        setTimeout(() => {
          this.setScrollingReserved(false);
        }, 2000)
      });
    },
  },

};
</script>

<style lang="scss" scoped>

</style>
